class Menu {
  constructor () {
    if (window.menu) return // Menu is static and already initialized
    this.init()
  }

  init () {
    const header = document.getElementById('header')
    // const mainMenu = document.getElementById('menu-main-menu')
    const mainMenuOpen = document.getElementById('main-menu-open')
    const mainMenuClose = document.querySelector('.c-menuLanguage__close')
    const menuLanguage = document.querySelector('.c-menuLanguage')
    const toggleItems = document.querySelectorAll('.c-menu .hasChildren')
    const checkBodyScroll = this.checkBodyScroll

    toggleItems.forEach(function (item) {
      item.addEventListener('click', function (e) {
        e.stopPropagation()
        item.classList.toggle('isOpen')
      })
    })

    const showMenu = function (event) {
      event.stopPropagation()
      header.classList.toggle('isOpen')
      checkBodyScroll()
    }

    const hideMenu = function () {
      header.classList.remove('isOpen')
      checkBodyScroll()
    }

    const handleClosure = event => (!mainMenuOpen.contains(event.target) && !menuLanguage.contains(event.target)) && hideMenu()

    mainMenuOpen.addEventListener('click', showMenu)
    mainMenuClose.addEventListener('click', hideMenu)

    window.addEventListener('click', handleClosure)
    window.addEventListener('focusin', handleClosure)
  }

  checkBodyScroll () {
    const body = document.body
    const header = document.getElementById('header')

    if (header.classList.contains('isOpen')) {
      body.classList.add('hasNoScroll')
      body.classList.add('hasMenuOpened')
    } else {
      body.classList.remove('hasNoScroll')
      body.classList.remove('hasMenuOpened')
    }
  }
}

export default Menu
